// SPA Configuration

// Explicitly define the file extensions that are allowed; these will be stripped from the URL so they can be rewritten
export const FILE_EXTENSIONS = ['pdf', 'jpg', 'png', 'doc', 'docx', 'xls', 'xlsx'];